import styled from '@emotion/styled'
import { Button, Typography } from '@mui/material'
import { LinkExternal } from '@emotion-icons/octicons/LinkExternal'
import { FC } from 'react'
import { Colors } from 'src/components/theme'

const Container = styled.div`
  padding: 20px;
  border-radius: 8px;
  background-color: white;
  width: 100%;
`

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`

const RightAction = styled(Button)`
  color: ${Colors.blueDark};
  background-color: white;
  text-transform: none;
  font-size: 14px;
  font-weight: 700;
  padding: 0px 12px;
`

type ModalCardProps = {
  title: string
  actionText?: string
  actionDisabled?: boolean
  onActionClick?: () => void
  children?: React.ReactNode
}

export const ModalCard: FC<ModalCardProps> = ({ title, actionText, onActionClick, actionDisabled, children }) => {
  return (
    <Container>
      <Header>
        <Typography variant="title1" color={Colors.neutral950}>
          {title}
        </Typography>
        {onActionClick && actionText && (
          <RightAction
            disabled={actionDisabled}
            onClick={onActionClick}
            variant="outlined"
            endIcon={<LinkExternal size={14} />}>
            {actionText}
          </RightAction>
        )}
      </Header>
      {children}
    </Container>
  )
}
